import React from 'react';
import DashboardOverview from './DashboardOverview';
import DashboardDetailSection from './DashboardDetailSection';
import EvolutionSection from './EvolutionSection';
import DashboardRanking from './DashboardRanking';
import AreaSummarySection from './AreaSummarySection';

/**
 * Renderiza el bloque DashboardView de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function DashboardView({
  v
}) {
  return v.viewPanel ? React.createElement(React.Fragment, null, React.createElement("div", {
    style: {
      "flex": "1",
      "minHeight": "0",
      "display": "grid",
      "gridTemplateColumns": v.gridCols,
      "gridTemplateRows": v.gridRows,
      "gap": v.gridGap / 10.8 + "vh"
    }
  }, v.text("\n    "), React.createElement(DashboardOverview, {
    v
  }), v.text("\n\n    "), React.createElement("div", {
    style: {
      "display": v.detDisp,
      "flexDirection": "column",
      "gap": "1.111111vh",
      "minHeight": "0",
      "minWidth": "0",
      "position": "relative",
      "zIndex": v.hDisp === "none" ? "1" : "100",
      "overflow": "visible",
      "gridColumn": v.detailCol,
      "gridRow": v.detailRow
    }
  }, v.text("\n      "), v.aggregateView ? React.createElement(AreaSummarySection, {
    summary: v.areaSummary
  }) : React.createElement(DashboardDetailSection, {
    v
  })), v.text("\n\n      "), React.createElement("div", {
    style: {
      "display": v.evoDisp,
      "flexDirection": v.evoDir,
      "gap": "1.111111vh",
      "flex": v.evoFlex,
      "height": v.evoH,
      "minHeight": "0",
      "position": "relative",
      "zIndex": "1",
      "gridColumn": v.bottomCol,
      "gridRow": v.bottomRow
    }
  }, React.createElement(EvolutionSection, {
    v
  }), React.createElement(DashboardRanking, {
    v
  })), v.text("\n  "))) : null;
}
